import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';
import MaterialSlider from 'material-ui/Slider';

import css from './scrubber.module.scss';

export default class Slider extends Component {
  static propTypes = {
    isDisabled: PropTypes.bool.isRequired,
    sliderMax: PropTypes.number.isRequired,
    elapsedPercent: PropTypes.number.isRequired,
    onChangeCommitted: PropTypes.func.isRequired,
    isInNowPlayingDialog: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      scrubbingPercent: 0,
    };

    this.onChange = this.onChange.bind(this);
    this.onDragStop = this.onDragStop.bind(this);
  }

  onChange(event, scrubbingPercent) {
    this.setState({ scrubbingPercent });
  }

  onDragStop() {
    this.props.onChangeCommitted(this.state.scrubbingPercent);
  }

  render() {
    const { sliderMax, isDisabled, elapsedPercent, isInNowPlayingDialog } =
      this.props;

    const sliderStyle = isInNowPlayingDialog
      ? { margin: '0px' }
      : { marginTop: '61px' };
    const sliderCss = isInNowPlayingDialog ? css.nowPlayingSlider : css.slider;

    return (
      <MaterialSlider
        id="scrubber"
        data-testid={`scrubber-disabled-${isDisabled}`}
        disableFocusRipple
        className={classNames(sliderCss, {
          [css.disabled]: isDisabled,
        })}
        disabled={isDisabled}
        value={elapsedPercent}
        sliderStyle={sliderStyle}
        max={sliderMax}
        onChange={this.onChange}
        onDragStop={this.onDragStop}
      />
    );
  }
}
